module.exports = __webpack_public_path__ + "static/media/sharechat-4.3f96d4c7.webp";